module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Ticket-30d60e801c5d1c5958545153508b72b5.svg";